import React from "react";
import Tickets from "../../../components/Tickets/Tickets";

export const TicketsPage = () => {
   return <Tickets />;
};
